import { useCallback } from 'react';
import { withStopPropagation } from '../lib/events';

export function useClickHandler(func, deps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(withStopPropagation(func), deps || [func]);
}
